type HeroGlowProps = {
  align?: "left" | "center";
  /** Park the ribbon behind the content instead of over it. Needed wherever it
   *  is dropped into a <main> full of static in-flow content rather than into a
   *  hero section that positions its own copy. The parent must carry `isolate`. */
  behind?: boolean;
};

/* The page-hero backdrop: the same gradient ribbon the homepage hero parks off
   its top-right corner, so every hero on the site opens on one colour field.
   No canvas and no three.js — it is pure CSS (see `.hero-ribbon` in
   globals.css), so it costs nothing on pages that aren't the homepage.

   `align` picks the readability fade laid over it: left-aligned heroes fade the
   ribbon out towards the left so the copy column keeps its contrast, centred
   heroes fade it from the middle outwards instead. */
export default function HeroGlow({ align = "center", behind = false }: HeroGlowProps) {
  return (
    <div
      className={`hero-ribbon-wrap band ${behind ? "behind" : ""}${align === "center" ? "fade-center" : "fade-left"}`}
      aria-hidden="true"
    >
      <div className="hero-ribbon" />
    </div>
  );
}
